module.exports = __webpack_public_path__ + "media/images/athletes/143-c997035f9d572b489c999f744a3e6566.png";